import { Component, Inject, EventEmitter, Output, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TableElementComponent } from '@uranda/ui';
import { WalletService } from '../../../../../services/wallet.service';

@Component({
    selector: 'app-send-quote-button',
    template: `
    <span *ngIf="isPurchased()" class="text-dark">
      {{ getPhoneNumber() }}
    </span>

    <button
      *ngIf="!isPurchased()"
      type="button"
      class="btn btn-xs status-table-btn no-arrow my-text"
      [ngClass]="getButtonClass()"
      [disabled]="isWalletDebtExceeded"
      (click)="handleClick($event)"
    >
      {{ getButtonText() }}
      <span
        *ngIf="canUnlock()"
        class="material-icons ms-1"
        style="font-size: 16px;"
      >
        lock_open
      </span>
    </button>
  `,
    standalone: false
})
export class SendQuoteButtonComponent extends TableElementComponent {
  @Output() unlockPhone = new EventEmitter<any>();
  @Input() onUnlockClicked?: (data: any) => void;

  constructor(
    @Inject('props') public override props: any,
    private translateService: TranslateService,
    private walletService: WalletService
  ) {
    super(props);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.onUnlockClicked = this.props.onUnlockClicked || this.props.onClick;
  }

  get isWalletDebtExceeded(): boolean {
    return this.walletService.isBlocked;
  }

  handleClick(event: Event): void {
    event.stopPropagation();
    if (this.canUnlock() && !this.isWalletDebtExceeded) {
      if (this.onUnlockClicked) {
        this.onUnlockClicked(this.data);
      } else {
        this.unlockPhone.emit(this.data);
      }
    }
  }

  isPurchased(): boolean {
    return this.data.status === 'PURCHASED';
  }

  isPending(): boolean {
    return this.data.status === 'PENDING';
  }

  canUnlock(): boolean {
    return this.isPending();
  }

  getPhoneNumber(): string {
    const lead = this.data.quote?.lead || this.data.contactRequest?.lead;
    return lead?.phoneNumber || '-';
  }

  getButtonText(): string {
    if (this.isPending()) {
      return this.translateService.instant('Unlock Phone Number');
    }
    return this.translateService.instant('Not Available');
  }

  getButtonClass(): string {
    if (this.canUnlock() && !this.isWalletDebtExceeded) {
      return 'btn-success text-white';
    }
    return 'btn-secondary text-white';
  }
}
